import { withStyles } from '@material-ui/core/styles';

export default withStyles((theme) => ({
  disabledAlumyText: {
    color: 'rgba(0, 0, 0, 0.38)',
    pointerEvents: 'none',
  },
  priceContainer: {
    [theme.breakpoints.up('sm')]: {
      flex: 1,
      maxWidth: 350,
    },
  },
}));
